<div class="background-modal"></div>
<div class="window-info-modal">
  <div class="header-row">
    <span>{{ 'projects.duplicateProject.title' | translate }} {{ project?.code }}</span>
  </div>
  <div class="field">
    <div class="label">
      {{ 'projects.duplicateProject.newProjectCode' | translate }}
    </div>
    <input [(ngModel)]="projectCode" focusSelect />
  </div>
  <div class="field">
    <label class="label">
      <input type="checkbox" [(ngModel)]="deliverables" />
      {{ 'projects.duplicateProject.deliverables' | translate }}
    </label>
  </div>
  <div class="field">
    <label class="label">
      <input type="checkbox" [(ngModel)]="departments" />
      {{ 'projects.duplicateProject.departments' | translate }}
    </label>
  </div>
  <div class="field">
    <label class="label">
      <input type="checkbox" [(ngModel)]="productionCost" />
      {{ 'projects.duplicateProject.productionCost' | translate }}
    </label>
  </div>
  <div class="button-row">
    <div class="cancel-btn" (click)="close()">
      {{ 'auth.settings.cancel' | translate }}
    </div>
    <div class="save-btn" (click)="onDuplicate()">
      {{ 'projects.duplicateProject.duplicate' | translate }}
    </div>
  </div>
</div>
